import React, { useState, useCallback, useEffect, useRef } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Switch,
    FormControlLabel,
    FormHelperText,
    Select,
    FormControl,
    InputLabel,
    InputAdornment,
    MenuItem,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Button,
    Stack,
    Avatar,
    IconButton,
    Chip,
    styled,
    Container,
    ListItem,
    ListItemButton,
    List,
    Fab,
    Table,
    TableContainer,
    TableCell,
    TableRow,
    TableBody,
    TableHead,
    Badge,
    Link,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    useMediaQuery,
} from '@mui/material';

import { red } from "@mui/material/colors";

import { useTheme } from '@mui/material/styles';

import * as yup from 'yup';

import { useFormik } from 'formik';
import { DataGrid, GridCellEditStopReasons, useGridApiContext } from '@mui/x-data-grid';

import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { useSystemPrompt } from "../../../../../hooks/useSystemPrompt";
import { useAppContextFeatures } from "../../../../../context/AppContext"
import { CommonIcons, icons } from '../../../../../components/common/CommonIcons'
// import { useSystemUtils } from "../../../../../hooks/useSystemUtils";
import { useSystemRoutes, routeTypes } from "../../../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../../../hooks/usePermissions';
import { useAuthAccess } from "../../../../../hooks/useAuthAccess"

import { useTranslations } from "../../../../../hooks/useTranslations";

import CommonBreadcumbs from "../../../../../components/common/CommonBreadcumbs";
import CommonSectionHeader from "../../../../../components/common/CommonSectionHeader";
import CommonRestricted from "../../../../../components/common/CommonRestricted";

// import ActionConfirm from "../../../../../components/dialog/ActionConfirm"

import { getInjectionDataType } from "../../../utils/injectionSelection";

import { useMarking, markingInjectionFields } from "../../../hooks/model/useMarking";
import { useProduct, productInjectionFields } from "../../../hooks/model/useProduct"
import { itemInjectionFields } from "../../../hooks/model/useProductItem";

import { useMarking as useSdgroupMarking } from "../../../hooks/sdgroupApi/useMarking";

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    '.super-app-theme--cell': {
        padding: 0,
        margin: 0,
        fontSize: 13,
        paddingLeft: 5,
        paddingRight: 5,
        backgroundColor: '#f3f3f3',
        '&.Mui-selected': {
            backgroundColor: '#f3f3f3',
            '&:hover': {
                backgroundColor: '#f3f3f3',
            },
        },
    },
    '.super-app-theme--cellEditable': {
        padding: 0,
        margin: 0,
        fontSize: 13,
        paddingLeft: 5,
        paddingRight: 5,
        '&.Mui-selected': {
            backgroundColor: '#fff',
            '&:hover': {
                backgroundColor: '#fff',
            },
        },
    },
    '.super-app-theme--Unsaved': {
        // padding: 0,
        // margin: 0,
        // fontSize: 13,
        // paddingLeft: 5,
        // paddingRight: 5,
        backgroundColor: 'yellow !important',
        '&.Mui-selected': {
            backgroundColor: 'yellow !important',
            '&:hover': {
                backgroundColor: 'yellow !important',
            },
        },
    },
    '& .super-app-theme--Open': {
        // backgroundColor: getBackgroundColor(theme.palette.info.main, theme.palette.mode),
        // '&:hover': {
        //     backgroundColor: getHoverBackgroundColor(
        //         theme.palette.info.main,
        //         theme.palette.mode,
        //     ),
        // },
        // '&.Mui-selected': {
        //     backgroundColor: getSelectedBackgroundColor(
        //         theme.palette.info.main,
        //         theme.palette.mode,
        //     ),
        //     '&:hover': {
        //         backgroundColor: getSelectedHoverBackgroundColor(
        //             theme.palette.info.main,
        //             theme.palette.mode,
        //         ),
        //     },
        // },
    },
    '& .super-app-theme--Filled': {
        // backgroundColor: getBackgroundColor(
        //     theme.palette.success.main,
        //     theme.palette.mode,
        // ),
        // '&:hover': {
        //     backgroundColor: getHoverBackgroundColor(
        //         theme.palette.success.main,
        //         theme.palette.mode,
        //     ),
        // },
        // '&.Mui-selected': {
        //     backgroundColor: getSelectedBackgroundColor(
        //         theme.palette.success.main,
        //         theme.palette.mode,
        //     ),
        //     '&:hover': {
        //         backgroundColor: getSelectedHoverBackgroundColor(
        //             theme.palette.success.main,
        //             theme.palette.mode,
        //         ),
        //     },
        // },
    },
    '& .super-app-theme--PartiallyFilled': {
        // backgroundColor: getBackgroundColor(
        //     theme.palette.warning.main,
        //     theme.palette.mode,
        // ),
        // '&:hover': {
        //     backgroundColor: getHoverBackgroundColor(
        //         theme.palette.warning.main,
        //         theme.palette.mode,
        //     ),
        // },
        // '&.Mui-selected': {
        //     backgroundColor: getSelectedBackgroundColor(
        //         theme.palette.warning.main,
        //         theme.palette.mode,
        //     ),
        //     '&:hover': {
        //         backgroundColor: getSelectedHoverBackgroundColor(
        //             theme.palette.warning.main,
        //             theme.palette.mode,
        //         ),
        //     },
        // },
    },
    '& .super-app-theme--Rejected': {
        // backgroundColor: getBackgroundColor(
        //     theme.palette.error.main,
        //     theme.palette.mode,
        // ),
        // '&:hover': {
        //     backgroundColor: getHoverBackgroundColor(
        //         theme.palette.error.main,
        //         theme.palette.mode,
        //     ),
        // },
        // '&.Mui-selected': {
        //     backgroundColor: getSelectedBackgroundColor(
        //         theme.palette.error.main,
        //         theme.palette.mode,
        //     ),
        //     '&:hover': {
        //         backgroundColor: getSelectedHoverBackgroundColor(
        //             theme.palette.error.main,
        //             theme.palette.mode,
        //         ),
        //     },
        // },
    },
}));

export const validationSearchSchema = yup.object({
    marking: yup
        .string()
        .required("Required"),
}).required();

export const initialSearchValues = {
    marking: "",
}

export const validationChangeToSchema = yup.object({
    marking: yup
        .string()
        .required("Required"),
    sourceMarkingRemId: yup
        .string()
        .required("Required"),
    branchId: yup
        .string()
        .required("Required"),
    userId: yup
        .string()
        .required("Required"),
    actionUserId: yup
        .string()
        .required("Required"),
    productIds: yup
        .array()
        .min(1, `Min 1 Item`),
}).required();

export const initialChangeToValues = {
    marking: "",
    companyName: "",
    branchCode: "",
    code: "",
    postcode: "",
    sourceMarkingRemId: "",
    branchId: "",
    userId: "",
    actionUserId: "",
    productIds: []
}

export const StyledIcon = styled(Box)({
    width: 100,
    height: 100,
    opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3),
    // minHeight: 450
}));

const RenderSearch = ({ formik, t }) => {

    const { values, errors, handleSubmit, handleChange } = formik

    return (
        <StyledCard>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={1}>

                    <Grid item xs={3} sm={3} md={3}>
                        <CommonSectionHeader
                            title={t('searchMarking')}
                            subTitle={t('searchRelatedProductsByTheMarking')}
                        />
                    </Grid>

                    <Grid item xs={3} sm={3} md={3}>
                        <TextField
                            margin="dense"
                            size="small"
                            fullWidth
                            name={`marking`}
                            label={t('marking')}
                            type="text"
                            variant="outlined"
                            value={values.marking}
                            onChange={handleChange}
                            error={errors?.marking ? Boolean(true) : false}
                            helperText={errors?.marking}
                        />
                    </Grid>

                    <Grid item xs={2} sm={2} md={2}>

                        <Button
                            variant="contained"
                            color="primary"
                            size="medium"
                            type="submit"
                        >
                            <CommonIcons
                                name={icons.search}
                                sx={{
                                    // width: 15,
                                    // height: 15
                                    mr: 1
                                }}
                            />
                            <Typography>
                                {t("search")}
                            </Typography>
                        </Button>

                    </Grid>

                </Grid>
            </form>
        </StyledCard>
    )
}

const RenderResult = ({
    formik,
    t,
    dataMarking,
    dataProducts,
    datagidColumns,
    selectedIds,
    handleRowSelectionModelChange,
    onConfirm
}) => {

    const { values, errors, handleSubmit, handleChange } = formik

    if (dataProducts.length <= 0) return <></>

    return (
        <Box>
            <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                sx={{
                    py: 1
                }}
            >
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"flex-start"}
                    alignItems={"center"}
                >
                    <Typography
                        sx={{
                            fontSize: 13,
                            py: 1,
                            px: 1
                        }}
                    >
                        ({dataProducts.length}) {t("latestResultFor")}
                    </Typography>
                    <Typography
                        sx={{
                            fontWeight: 800,
                            fontSize: 18,
                            ml: 1
                        }}
                    >
                        {dataMarking?.markingCompanyName} (MarkingId : {dataMarking?.markingId})
                    </Typography>
                </Box>
                <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    disabled={selectedIds.length <= 0}
                    onClick={onConfirm}
                >
                    <Badge
                        badgeContent={selectedIds.length}
                        color="error"
                    >
                        <CommonIcons
                            name={icons.switch}
                            sx={{
                                mr: 1
                            }}
                        />
                        <Typography>
                            {t("changeOwner")}
                        </Typography>
                    </Badge>

                </Button>
            </Box>
            <StyledCard
                sx={{
                    p: 0
                }}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>

                        <Grid item xs={12} sm={12} md={12}>
                            <StyledDataGrid
                                sx={{
                                    p: 0,
                                    fontSize: 12,
                                    // minHeight: 350,
                                }}
                                rows={dataProducts}
                                columns={datagidColumns}
                                checkboxSelection
                                rowHeight={25}
                                // getRowClassName={(params) => `super-app-theme--${params.row.isChanged}`}

                                rowSelectionModel={selectedIds}
                                onRowSelectionModelChange={handleRowSelectionModelChange}
                                disableRowSelectionOnClick

                            />
                        </Grid>

                        {/* <Grid item xs={12} sm={12} md={12}>
                            {JSON.stringify(dataMarking)}
                            {JSON.stringify(dataProducts)}
                        </Grid> */}


                    </Grid>
                </form>
            </StyledCard>
        </Box>
    )
}

const RenderDialog = ({
    formik,
    t,
    dialogOpen,
    dialogParams,
    onClose,
    onCancel,
    onSearch,
    onSave
}) => {

    const { values, handleSubmit, handleChange, errors } = formik

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    // contructs errors string
    let errorArray = []

    Object.keys(errors).forEach((i) => {
        errorArray.push(`${i}: ${errors[i]}`)
    })

    let errorString = errorArray.join(", ")

    // console.log('errorString', errorString)

    return (
        <Dialog
            open={dialogOpen}
            onClose={onClose}
            fullScreen={fullScreen}
            maxWidth={`lg`}
        >
            <DialogTitle>{`${t('changeOwner')} - ${t("applyTo")} ${values.productIds.length} ${t("products")}`}</DialogTitle>

            <DialogContent>
                <form onSubmit={handleSubmit}>
                    {/* {JSON.stringify(values)}
                    {JSON.stringify(errors)} */}
                    <Grid container spacing={1}>

                        <Grid item xs={8} sm={8} md={8}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={`marking`}
                                label={t('marking')}
                                type="text"
                                variant="outlined"
                                value={values.marking}
                                onChange={handleChange}
                                error={errors?.marking ? Boolean(true) : false}
                                helperText={errors?.marking}
                            />
                        </Grid>

                        <Grid item xs={4} sm={4} md={4}>

                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                onClick={onSearch}
                            >
                                <CommonIcons
                                    name={icons.search}
                                    sx={{
                                        mr: 1
                                    }}
                                />
                                <Typography>
                                    {t('Search')}
                                </Typography>
                            </Button>

                        </Grid>

                        <Grid item xs={12} sm={12} md={12}>

                            <Typography
                                sx={{
                                    fontSize: 18,
                                    fontWeight: 800
                                }}
                            >
                                {t("confirmChangeOwnerToThisMarking")}
                            </Typography>

                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} size="small" aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{t("marking")}</TableCell>
                                            <TableCell align="left">{t("companyName")}</TableCell>
                                            <TableCell align="center">{t("postcode")}</TableCell>
                                            <TableCell align="left">{t("sourceMarkingRemId")}</TableCell>
                                            <TableCell align="left">{t("branchId")}</TableCell>
                                            <TableCell align="left">{t("userId")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell component="th" scope="row">{values.marking}</TableCell>
                                            <TableCell align="left">{values.companyName}</TableCell>
                                            <TableCell align="center">{values.postcode}</TableCell>
                                            <TableCell align="left">{values.sourceMarkingRemId}</TableCell>
                                            <TableCell align="left">{values.branchId}</TableCell>
                                            <TableCell align="left">{values.userId}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Grid>

                        <Grid item xs={12} sm={12} md={12}>
                            <Typography
                                sx={{
                                    color: red[500],
                                    fontSize: 13
                                }}
                            >
                                {errorString}
                            </Typography>
                        </Grid>

                    </Grid>
                </form>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onCancel}
                >
                    {t('cancel')}
                </Button>
                <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={onSave}
                    disabled={
                        Object.keys(errors).length > 0
                    }
                >
                    {t('confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default function ChangeProductOwner({
    routeType
}) {

    const { t } = useTranslations({ ns: ["_@products", "_@repositories", "_prompt", "common", "_common"] })

    const { id } = useParams();

    const { promptMessage } = useSystemPrompt();
    const { setSystemLoading, openCustomDrawer, closeCustomDrawer } = useAppContextFeatures();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.product.id, scopeTypes.product.product.id)

    const { authData } = useAuthAccess(routeType)

    const { listMarkings, filterOperatorTypes } = useMarking({ routeType })
    const { listProducts, changeProductsOwner } = useProduct({ routeType })

    const [dataMarking, setDataMarking] = useState({})
    const [dataProducts, setDataProducts] = useState([])
    const [selectedIds, setSelectedIds] = useState([])

    const [dialogOpen, setDialogOpen] = useState(false)
    const [dialogParams, setDialogParams] = useState({})

    const { listMarkings: listSdgroupMarkings } = useSdgroupMarking({ routeType })

    const handleSearch = async (values) => {

        setSystemLoading(true);

        try {

            const marking = values?.marking

            let encodedMarkingValue = encodeURIComponent(marking)

            console.log('encodedMarkingValue >>>', encodedMarkingValue)

            let props = {
                limit: 100,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [
                    {
                        name: `${markingInjectionFields.marking.retrieveKey}`,
                        operator: filterOperatorTypes.eq,
                        value: encodedMarkingValue
                    }
                ],
            }

            const { count, data } = await listMarkings({
                props,
                status: `1`
            })

            // console.log('cont', count, data)

            // check the marking search must appear
            if (data.length <= 0) {
                throw new Error(`${t('invalidMarking')}`)
            }

            // check the marking search cannot duplicated
            if (data.length > 1) {
                throw new Error(`${t('moreThanOneMarkingExists')}`)
            }

            let markingId = data[0]?.id
            let markingCompanyName = data[0]?.company_name

            setDataMarking({
                markingId,
                markingCompanyName
            })

            // search related products to latest up to 50 records
            props = {
                limit: 50,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: -1,
                },
                filterValue: [
                    {
                        name: `${productInjectionFields.customerBranchId.retrieveKey}`,
                        operator: filterOperatorTypes.eq,
                        value: markingId
                    }
                ],
            }

            let result = await listProducts({
                props,
                dataTypes: [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]
            })

            // console.log('result', result)

            setDataProducts(result.data)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }

    const handleChangeTo = async (values) => {

        setSystemLoading(true);

        try {

            const marking = values?.marking

            let encodedMarkingValue = encodeURIComponent(marking)

            let props = {
                limit: 100,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [
                    {
                        name: `${markingInjectionFields.marking.retrieveKey}`,
                        operator: filterOperatorTypes.eq,
                        value: encodedMarkingValue
                    }
                ],
            }

            const { count, data } = await listMarkings({
                props,
                status: `1`
            })

            console.log('cont', count, data)

            // check the marking search must appear
            if (data.length <= 0) {
                throw new Error(`${t('invalidMarking')}`)
            }

            // check the marking search cannot duplicated
            if (data.length > 1) {
                throw new Error(`${t('moreThanOneMarkingExists')}`)
            }

            let markingId = data[0]?.id
            let markingCompanyName = data[0]?.company_name

            setDataMarking({
                markingId,
                markingCompanyName
            })

            // search related products to latest up to 50 records
            props = {
                limit: 50,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: -1,
                },
                filterValue: [
                    {
                        name: `${productInjectionFields.customerBranchId.retrieveKey}`,
                        operator: filterOperatorTypes.eq,
                        value: markingId
                    }
                ],
            }

            let result = await listProducts({
                props,
                dataTypes: [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]
            })

            // console.log('result', result)

            setDataProducts(result.data)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }

    const getBreadcumbActionMenus = () => {

        let props = []

        // if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id })) {
        //     props.push({
        //         displayText: "Edit Item",
        //         href: getRoute(`product/item/update/${id}`),
        //     })
        // }

        return props

    }

    const formikSearch = useFormik({
        initialValues: initialSearchValues,
        validationSchema: validationSearchSchema,
        enableReinitialize: true,
        onSubmit: handleSearch
    });

    // console.log('authData', authData)

    const getChangeToInitialValues = () => {
        return {
            ...initialChangeToValues,
            actionUserId: authData?.userId
        }
    }

    const formikChangeTo = useFormik({
        initialValues: getChangeToInitialValues(),
        validationSchema: validationChangeToSchema,
        enableReinitialize: true,
        onSubmit: handleChangeTo
    });

    const datagidColumns = [
        { field: `id`, headerName: t("sysId"), width: 80, sortable: true },
        { field: `${productInjectionFields.customerMarking.retrieveKey}`, headerName: t("marking"), width: 180, sortable: true },
        { field: `ax_createdatetime`, headerName: t("createdAt"), width: 150, sortable: true },
        {
            field: `ax_createuserid`, headerName: t("packUnit"), width: 80, sortable: true,
            renderCell: (params) => {

                let items = params.row?.items ? params.row.items : []

                let totalPackQty = items.reduce((total, i) => {
                    // console.log('i', i)
                    total += parseInt(i[itemInjectionFields.packQty.retrieveKey], 10)
                    return total
                }, 0)

                // console.log('totalPackQty', totalPackQty)

                return (
                    <Typography
                        sx={{
                            fontSize: 13
                        }}
                    >
                        {
                            totalPackQty
                        }
                    </Typography>
                )
            }
        },
        {
            field: `brand_name`, headerName: t("tCbm"), width: 80, sortable: true,
            renderCell: (params) => {

                let items = params.row?.items ? params.row.items : []

                // console.log('items', items)

                let totalCbm = items.reduce((total, i) => {
                    // console.log('i', i)
                    total += parseFloat(i[itemInjectionFields.totalCbm.retrieveKey])
                    return total
                }, 0)

                // console.log('totalCbm', totalCbm)

                return (
                    <Typography
                        sx={{
                            fontSize: 13
                        }}
                    >
                        {
                            totalCbm.toFixed(4)
                        }
                    </Typography>
                )
            }
        },
        { field: `${productInjectionFields.supplierName.retrieveKey}`, headerName: t("supplier"), width: 120, sortable: true },
        { field: `${productInjectionFields.courierTrackingNo.retrieveKey}`, headerName: t("courierNo"), width: 160, sortable: true },
        { field: `${productInjectionFields.signedByUserDisplay.retrieveKey}`, headerName: t("signedByUser"), width: 100, sortable: true },
        { field: `${productInjectionFields.remark.retrieveKey}`, headerName: t("remark"), width: 140, sortable: true },
        {
            field: `${productInjectionFields.loadStatus.retrieveKey}`, headerName: t("status"), width: 100, sortable: true,
            renderCell: (params) => {

                let loadContainerId = params.row[productInjectionFields.loadContainerId.retrieveKey]
                let _loadStatus = params.row[productInjectionFields.loadStatus.retrieveKey]
                let loadStatus = _loadStatus ? _loadStatus.toLowerCase() : ''


                // let _container = {}

                // if (loadContainerId) {
                //     _container = dataContainers.filter(i => i?.id === loadContainerId)
                // }

                // // console.log('loadContainerId,', loadContainerId, _container, dataContainers)

                // let containerInfo = _container.length > 0 ? _container[0] : {}

                return (
                    <Typography
                        sx={{
                            fontSize: 13,
                            // fontWeight: '800'
                        }}
                    >
                        {t(loadStatus)}
                    </Typography>
                )
            }
        },
        { field: `${productInjectionFields.sourceProductRemId.retrieveKey}`, headerName: t("sourceProductRemId"), width: 200, sortable: true },
    ];

    const handleNext = () => {

        try {

            // double check the all selection product ids have sourceproductremid
            let emptySourceProductRemIdCount = 0

            selectedIds.forEach(i => {
                let productId = i
                let _p = dataProducts.filter(i2 => i2.id === productId)

                if (_p.length > 0) {
                    if (!_p[0][productInjectionFields.sourceProductRemId.retrieveKey]) {
                        emptySourceProductRemIdCount += 1
                    }
                }

            })

            if (emptySourceProductRemIdCount > 0) {
                throw Error(`sourceProductRemId cannot be empty`)
            }

            formikChangeTo.setFieldValue(`productIds`, selectedIds)
            setDialogOpen(true)
            setDialogParams({})

        } catch (error) {
            promptMessage(false, `${t(error)}`)
        }

    }

    const onSearchChangeToMarking = async () => {

        setSystemLoading(true);

        try {

            const marking = formikChangeTo?.values?.marking

            let encodedMarkingValue = encodeURIComponent(marking)

            if (!encodedMarkingValue) {
                throw new Error(`${t('markingCannotEmpty')}`)
            }

            if (encodedMarkingValue.toLowerCase() === formikSearch.values?.marking.toLowerCase()) {
                throw new Error(`${t('markingCannotBeSame')}`)
            }

            // get the marking infor from wms first, the hub is the source of truth for which upstream marking is linked
            let props2 = {
                limit: 100,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [
                    {
                        name: `${markingInjectionFields.marking.retrieveKey}`,
                        operator: filterOperatorTypes.eq,
                        value: encodedMarkingValue
                    }
                ],
            }

            const { data } = await listMarkings({
                props: props2,
                status: `1`
            })

            // check the marking search must appear
            if (data.length <= 0) {
                throw new Error(`${t('invalidMarking')}`)
            }

            // check the marking search cannot duplicated
            if (data.length > 1) {
                throw new Error(`${t('moreThanOneMarkingExists')}`)
            }

            let sourceMarkingRemId = data[0][markingInjectionFields.sourceMarkingRemId.retrieveKey]

            // check the sdgroup public api for the marking status
            let props1 = {
                limit: 100,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [
                    {
                        name: `marking`,
                        operator: filterOperatorTypes.eq,
                        value: encodedMarkingValue
                    }
                ],
            }

            const { data: dataUpstream } = await listSdgroupMarkings({
                props: props1,
            })

            // upstream can hold several records with the same marking (old deactivated customers keep theirs), so pick by remid
            const upstreamMarking = dataUpstream.find(i => i?.remid === sourceMarkingRemId)

            if (!upstreamMarking) { // not found
                throw new Error(`${t('invalidMarkingInUpstream')}`)
            }

            if (parseInt(upstreamMarking?.is_trash, 10) === 1) { // is trashed
                throw new Error(`${t('markingIsTrashInUpstream')}`)
            }

            if (parseInt(upstreamMarking?.deleted, 10) === 1) { // is deleted
                throw new Error(`${t('markingIsDeletedInUpstream')}`)
            }

            if (parseInt(upstreamMarking?.is_activate, 10) === 0) { // is deactivated
                throw new Error(`${t('markingIsDisabledInUpstream')}`)
            }

            let upStreamMarkingRemId = upstreamMarking?.remid

            // console.log('data', data)

            const { setValues, values } = formikChangeTo

            setValues({
                ...values,
                branchId: data[0]?.id,
                userId: data[0]?.user_id,
                marking: data[0][markingInjectionFields.marking.retrieveKey],
                companyName: data[0]?.company_name,
                branchCode: data[0]?.branch_code,
                code: data[0]?.code,
                postcode: data[0][markingInjectionFields.postcode.retrieveKey],
                sourceMarkingRemId: upStreamMarkingRemId
            })

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }

    const onConfirm = async () => {

        setSystemLoading(true)

        const { values } = formikChangeTo

        try {

            let _products = dataProducts.filter(i => values.productIds.includes(i?.id))
            let products = _products.map(i => ({
                productId: i?.id,
                fromMarking: i[productInjectionFields.customerMarking.retrieveKey],
                fromMarkingId: i[productInjectionFields.customerBranchId.retrieveKey],
                fromMarkingUserId: i[productInjectionFields.customerUserId.retrieveKey],
                sourceProductRemId: i[productInjectionFields.sourceProductRemId.retrieveKey]
            }))

            let payload = {
                // productIds: values.productIds,
                products,
                toMarkingId: values.branchId,
                toMarkingUserId: values.userId,
                toMarking: values.marking,
                toSourceMarkingRemId: values.sourceMarkingRemId,
                actionUserId: values.actionUserId
            }

            // console.log('payload', payload)

            await changeProductsOwner(payload)

            // console.log('validateSchema', validateSchema)

            // await updateProductRemarkIP({
            //     productId: dialogParams?.productId,
            //     remark: dialogParams?.remark
            // })

            // setDialogOpen(false)
            // setDialogParams({})

            // loadData(id)

            handleSearch(formikSearch.values)
            formikChangeTo.setValues(getChangeToInitialValues())
            setDialogOpen(false)
            setDialogParams({})

            promptMessage(true, `${"successChangeOwner"}`)

        } catch (error) {

            promptMessage(false, `Error: ${JSON.stringify(error)}`)
        }

        setSystemLoading(false)

    }

    return (
        <Box
            sx={{
                mb: 20
            }}
        >
            {
                getHtmlHead({ routeType, title: `${t('changeOwner')}` })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t('changeOwner')}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: t('changeOwner'),
                        props: {
                            href: getRoute("products/changeOwner")
                        }
                    },
                    {
                        displayText: `${t('changeOwner')} (*)`,
                        props: {
                            color: 'secondary.main'
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    (
                        <Grid container spacing={0} textAlign={"left"}>
                            <Grid item xs={12} sm={12} md={12}>

                                <RenderSearch
                                    formik={formikSearch}
                                    t={t}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>

                                <RenderResult
                                    formik={formikSearch}
                                    t={t}
                                    dataMarking={dataMarking}
                                    dataProducts={dataProducts}
                                    datagidColumns={datagidColumns}
                                    selectedIds={selectedIds}
                                    handleRowSelectionModelChange={(ids) => {
                                        // console.log('props', ids)

                                        // const selectedIDs = new Set(ids);
                                        // const selectedRowData = rows.filter((row) => selectedIDs.has(row.id.toString()))

                                        // console.log(selectedRowData);

                                        setSelectedIds(ids)
                                    }}
                                    onConfirm={handleNext}
                                />

                            </Grid>


                        </Grid>
                    )
                    :
                    <CommonRestricted />
            }

            <RenderDialog
                formik={formikChangeTo}
                t={t}
                dialogOpen={dialogOpen}
                dialogParams={dialogParams}
                onClose={() => {
                    formikChangeTo.setValues(getChangeToInitialValues())
                    setDialogOpen(false)
                    setDialogParams({})
                }}
                onCancel={() => {
                    formikChangeTo.setValues(getChangeToInitialValues())
                    setDialogOpen(false)
                    setDialogParams({})
                }}
                onSave={onConfirm}
                onSearch={onSearchChangeToMarking}
            />


        </Box>
    )
}